<div class="row">
  <div data-zid="toggle-tax" (click)="toggleTax()" class="d-flex flex-grow justify-content-between no-select cursor-pointer">
    <h3 class="zero-text p-base-med">
      {{ 'user-self-service.tax.headline' | transloco }}
      @if (showMe && !shouldDisplayNotAvailableHint) {
        <small>
          {{
            customerBaseData?.lastCsvUpdate
              ? ('user-self-service.tax.csvUpdateDate' | transloco: { date: (customerBaseData.lastCsvUpdate | date) ?? null })
              : ('user-self-service.tax.csvUpdate' | transloco)
          }}
        </small>
      }
    </h3>
    <web-design-system-icon name="chevron" [class.icon-rotate]="!showMe" />
  </div>
</div>
@if (showMe) {
  @if (shouldDisplayNotAvailableHint) {
    <div class="row" data-zid="tax-not-available">
      <div class="col-12 mt-3 mb-2">
        {{ 'user-self-service.tax.not-available' | transloco }}
      </div>
    </div>
  } @else if (taxFacade.loading$ | async) {
    <div class="row" data-zid="tax-loading">
      <div class="col-12 mt-3 mb-2 text-center">
        <output class="spinner-border text-primary">
          <span class="sr-only">Loading...</span>
        </output>
      </div>
    </div>
  } @else if (taxFacade.isReady$ | async) {
    <div class="row" data-zid="tax-data">
      <div class="col-12 mt-3 mb-2 pl-0">
        <div class="nav nav-tabs pr-3">
          @for (taxItem of taxFacade.tax$ | async; track $index) {
            <div class="nav-item" (click)="activeYear = taxItem.calendarYear">
              <a class="nav-link cursor-pointer font-medium text-no-wrap" [class.active]="activeYear === taxItem.calendarYear">
                {{ taxItem.calendarYear }}
              </a>
            </div>
          }
          <div class="nav-item hidden-sm hidden-xs hidden-md placeholder"></div>
        </div>
      </div>
      @for (taxItem of taxFacade.tax$ | async; track $index) {
        @if (showMe && activeYear === taxItem.calendarYear) {
          <div class="col-12 mb-4" [attr.data-zid]="'tax-item-' + taxItem.calendarYear">
            <div class="row">
              <div class="pl-0 col-12 mb-2">
                <h5 class="zero-text p-small-bold">{{ 'user-self-service.tax.fsa' | transloco | uppercase }}</h5>
              </div>
              <div class="pl-0 col-6 col-md-2">
                {{ 'user-self-service.tax.fsaAmount' | transloco }}
              </div>
              <div class="col-6 col-md-10 text-right text-md-left">
                {{ taxItem.fsaAmount ? (taxItem.fsaAmount | currency: 'EUR' : 'symbol' : '0.2-2' : 'de') : 'Nein' }}
              </div>
              <div class="pl-0 col-6 col-md-2">
                {{ 'user-self-service.tax.fsaRemaining' | transloco }}
              </div>
              <div class="col-6 col-md-10 text-right text-md-left">
                {{ taxItem.fsaAmount ? (taxItem.fsaRemaining | currency: 'EUR' : 'symbol' : '0.2-2' : 'de') : '-' }}
              </div>
              <div class="pl-0 col-6 col-md-2">
                {{ 'user-self-service.tax.fsaUsed' | transloco }}
              </div>
              <div class="col-6 col-md-10 text-right text-md-left">
                {{ taxItem.fsaAmount ? (taxItem.fsaUsed | currency: 'EUR' : 'symbol' : '0.2-2' : 'de') : '-' }}
              </div>
              <div class="pl-0 col-6 col-md-2">
                {{ 'user-self-service.tax.fsaValidTo' | transloco }}
              </div>
              <div class="col-6 col-md-10 text-right text-md-left">
                {{ taxItem.fsaAmount ? (taxItem.fsaValidTo | date) : '-' }}
              </div>
            </div>
            @if (activeYear === currentYear) {
              <div class="row mt-4">
                <div class="col-12 pl-0 pr-0" [innerHTML]="'user-self-service.tax.change-fsa.hints' | transloco"></div>
              </div>
              <self-service-switch-change-fsa [customerBaseData]="customerBaseData" />
            }
            <div class="row">
              <div class="pl-0 col-12 margin-top-15 mb-2">
                <h5 class="zero-text p-small-bold">{{ 'user-self-service.tax.nva' | transloco | uppercase }}</h5>
              </div>
              <div class="pl-0 col-6 col-md-2">{{ 'user-self-service.tax.nvaValidToBool' | transloco }}</div>
              <div class="col-6 col-md-10 text-right text-md-left">
                {{ taxItem.nvaValidTo ? 'Ja' : 'Nein' }}
              </div>
              <div class="pl-0 col-6 col-md-2">
                {{ 'user-self-service.tax.nvaValidTo' | transloco }}
              </div>
              <div class="col-6 col-md-10 text-right text-md-left">
                {{ taxItem.nvaValidTo ? 'Bis ' + (taxItem.nvaValidTo | date) : '-' }}
              </div>
              <div class="pl-0 col-12 margin-top-15 mb-2">
                <h5 class="zero-text p-small-bold">{{ 'user-self-service.tax.vvt' | transloco | uppercase }}</h5>
              </div>
              <div class="pl-0 col-4 col-md-2 text-nowrap">
                {{ 'user-self-service.tax.vvtAktien' | transloco }}
              </div>
              <div class="col-8 col-md-4 text-nowrap text-align-right">
                {{ taxItem.vvtAktien | currency: 'EUR' : 'symbol' : '0.2-2' : 'de' }}
              </div>
              <div class="pl-0 col-4 col-md-2 text-nowrap">
                {{ 'user-self-service.tax.vvtSonst' | transloco }}
              </div>
              <div class="col-8 col-md-4 text-nowrap text-align-right">
                {{ taxItem.vvtSonst | currency: 'EUR' : 'symbol' : '0.2-2' : 'de' }}
              </div>
              @if ((resetVvtAllowed$ | async) && activeYear === currentYear) {
                <div class="col-12 pl-0 margin-top-15">
                  <self-service-vvt-reset [customerId]="currentCustomer.custId" />
                </div>
              }
              <div class="pl-0 col-12 margin-top-15 mb-2">
                <h5 class="zero-text p-small-bold">{{ 'user-self-service.tax.payedTax' | transloco | uppercase }}</h5>
              </div>
              <div class="pl-0 col-12 col-md-6">
                <div class="row">
                  <div class="col-6 text-nowrap">
                    {{ 'user-self-service.tax.payedTaxAktien' | transloco }}
                  </div>
                  <div class="col-6 text-align-right">
                    {{ taxItem.payedTaxAktien | currency: 'EUR' : 'symbol' : '0.2-2' : 'de' }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 text-nowrap">
                    {{ 'user-self-service.tax.payedTaxAktienAbgeltung' | transloco }}
                  </div>
                  <div class="col-6 text-nowrap text-align-right">
                    {{ taxItem.payedTaxAktienAbgeltung | currency: 'EUR' : 'symbol' : '0.2-2' : 'de' }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 text-nowrap">
                    {{ 'user-self-service.tax.payedTaxAktienSoli' | transloco }}
                  </div>
                  <div class="col-6 text-nowrap text-align-right">
                    {{ taxItem.payedTaxAktienSoli | currency: 'EUR' : 'symbol' : '0.2-2' : 'de' }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 text-nowrap">
                    {{
                      'user-self-service.tax.payedTaxAktienKirche'
                        | transloco: { tax: taxItem.kirchenSteuerSatz ? taxItem.kirchenSteuerSatz : 0 }
                    }}
                  </div>
                  <div class="col-6 text-nowrap text-align-right">
                    {{ taxItem.payedTaxAktienKirche | currency: 'EUR' : 'symbol' : '0.2-2' : 'de' }}
                  </div>
                </div>
              </div>
              <div class="pl-0 col-12 col-md-6 margin-sm-top-15 margin-xs-top-15">
                <div class="row">
                  <div class="col-6 text-nowrap">
                    {{ 'user-self-service.tax.payedTaxSonst' | transloco }}
                  </div>
                  <div class="col-6 text-nowrap text-align-right">
                    {{ taxItem.payedTaxSonst | currency: 'EUR' : 'symbol' : '0.2-2' : 'de' }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 text-nowrap">
                    <span class="hidden-md hidden-lg hidden-xl">
                      {{ 'user-self-service.tax.payedTaxSonstAbgeltung' | transloco }}
                    </span>
                  </div>
                  <div class="col-6 text-nowrap text-align-right">
                    {{ taxItem.payedTaxSonstAbgeltung | currency: 'EUR' : 'symbol' : '0.2-2' : 'de' }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 text-nowrap">
                    <span class="hidden-md hidden-lg hidden-xl">
                      {{ 'user-self-service.tax.payedTaxSonstSoli' | transloco }}
                    </span>
                  </div>
                  <div class="col-6 text-nowrap text-align-right">
                    {{ taxItem.payedTaxSonstSoli | currency: 'EUR' : 'symbol' : '0.2-2' : 'de' }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 text-nowrap">
                    <span class="hidden-xl hidden-lg hidden-md">
                      {{
                        'user-self-service.tax.payedTaxSonstKirche'
                          | transloco: { tax: taxItem.kirchenSteuerSatz ? taxItem.kirchenSteuerSatz : 0 }
                      }}
                    </span>
                  </div>
                  <div class="col-6 text-nowrap text-align-right">
                    {{ taxItem.payedTaxSonstKirche | currency: 'EUR' : 'symbol' : '0.2-2' : 'de' }}
                  </div>
                </div>
              </div>
              <div class="pl-0 col-12 margin-top-15">
                {{ 'user-self-service.tax.qstGuthaben' | transloco }}
                {{ taxItem.qstGuthaben | currency: 'EUR' : 'symbol' : '0.2-2' : 'de' }}
              </div>
              <div class="pl-0 col-12 mt-3">
                <p class="font-size-smaller1" [innerHTML]="'user-self-service.tax.qstHint' | transloco"></p>
              </div>
              <div class="pl-0 col-12">
                <p class="font-size-smaller1" [innerHTML]="'user-self-service.tax.hint' | transloco"></p>
              </div>
            </div>
          </div>
        }
      }
    </div>
  } @else {
    <div class="row" data-zid="tax-not-ready">
      <div class="col-12 mt-3 mb-2 pl-0">
        {{ 'user-self-service.tax.notReady' | transloco }}
      </div>
    </div>
  }
}
